import { WorkspaceResourceFolderType } from "common/interfaces";
import { WorkspaceResourceType } from "common/interfaces";
import { IWorkspaceResource } from "common/interfaces";
import { IWorkspaceResourceFolder } from "common/interfaces";

export interface FolderPathInfo {
    pathParts: string[];
    displayLabel: string;
    folderId: string;
    parentFolderId?: string;
    folderType: WorkspaceResourceFolderType;
}

const MAX_FOLDER_PATH_DEPTH = 4;

export type FolderPathSegment = {
    id: string;
    name: string;
};

export function buildFolderPathSegments(
    folderId: string,
    resourceFolders: IWorkspaceResourceFolder[],
): FolderPathSegment[] {
    const segments: FolderPathSegment[] = [];
    let folder = resourceFolders.find(f => f.id === folderId);
    let depth = 0;
    while (folder && depth < MAX_FOLDER_PATH_DEPTH) {
        segments.unshift({ id: folder.id, name: folder.name });
        folder = folder.parentFolderId
            ? resourceFolders.find(f => f.id === folder.parentFolderId)
            : undefined;
        depth++;
    }
    return segments;
}

export function getFolderPathsForPresentation(
    resource: IWorkspaceResource,
    resourceFolders: IWorkspaceResourceFolder[]
): FolderPathInfo[] | undefined {
    const folderIds = resource.folderIds;

    return Array.from(folderIds).map(folderId => {
        const folder = resourceFolders.find(f => f.id === folderId);

        if (!folder) return undefined;

        const pathParts = buildFolderPathSegments(folderId, resourceFolders).map(segment => segment.name);
        const displayLabel = pathParts.length > 1 ? pathParts[pathParts.length - 1]! : pathParts[0] ?? "";
        return {
            pathParts,
            displayLabel,
            folderId,
            parentFolderId: folder?.parentFolderId,
            folderType: folder?.folderType ?? WorkspaceResourceFolderType.PERSONAL,
        };
    }).filter(Boolean);
}
